module.exports = __webpack_public_path__ + "img/icon_back_wh.8f1afe09.svg";